import { LOCALE_NAMES, LOCALES, type Locale } from "@/i18n";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

/**
 * A language picker for forms and the profile settings (signed out, the header has
 * LanguageSwitcher). Names are in their own language.
 */
export function LanguageSelect({
  id,
  testId,
  value,
  onChange,
  ...aria
}: {
  id?: string;
  testId?: string;
  value: Locale;
  onChange: (locale: Locale) => void;
  "aria-label"?: string;
}) {
  return (
    <Select value={value} onValueChange={(next) => onChange(next as Locale)}>
      <SelectTrigger
        id={id}
        className="w-full"
        aria-label={aria["aria-label"]}
        data-testid={testId}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {LOCALES.map((locale) => (
          <SelectItem key={locale} value={locale} data-testid={`language-option-${locale}`}>
            {LOCALE_NAMES[locale]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
